// i18n area 'hci' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.fr-FR.meta.json.
import type { enUS } from './hci'

export const frFR: typeof enUS = {
  hci: {
    ceph: {
      title: 'Clusters Ceph',
      createButton: 'Créer un cluster Ceph',
      emptyTitle: 'Aucun cluster Ceph géré',
      emptyBody: "TVirt déploie et possède Ceph sur les nœuds membres, en hyperconvergence avec la charge VM. Créez un cluster : le premier monitor et son manager naissent automatiquement sur le nœud de contrôle choisi — puis faites-le grandir avec d'autres monitors et périphériques OSD.",
      pageTitle: 'Clusters Ceph',
      colState: 'État',
      colMembers: 'Membres',
      colSize: 'Taille',
      colVersion: 'Version Ceph',
      sizeCell: '{used} GiB utilisés sur {total} GiB au total',
      phase: {
        'not-deployed': 'Non déployé',
        deploying: 'Déploiement en cours',
        healthy: 'En bonne santé',
        degraded: 'Dégradé',
        error: 'Erreur',
        destroying: 'En destruction',
        destroyed: 'Détruit'
      },
      health: {
        HEALTH_OK: 'En bonne santé (HEALTH_OK)',
        HEALTH_WARN: 'Avec avertissements (HEALTH_WARN)',
        HEALTH_ERR: 'En erreur (HEALTH_ERR)',
        unknown: 'Pas encore observée',
        observedAt: 'observée {time}'
      },
      create: {
        title: 'Créer un cluster Ceph',
        info: 'Quand on crée un nouveau cluster Ceph, il faut choisir le premier nœud sur lequel seront installés les rôles MON et MGR. Il faut aussi préciser quel subnet utiliser pour le trafic Ceph : le subnet public sert au trafic réseau général, tandis que le subnet cluster sert aux répliques internes entre les OSD ; des subnets différents ne sont pas strictement nécessaires.',
        controlNode: 'Nœud de contrôle',
        controlNodeHint: 'Le nœud membre où naissent le premier MON + MGR.',
        publicSubnet: 'Subnet public',
        publicSubnetHint: "Un Subnet enregistré dans l'IPAM — la public_network de Ceph. Immuable après la création.",
        clusterSubnet: 'Subnet cluster',
        clusterSubnetHint: "Un Subnet enregistré dans l'IPAM — la cluster_network de Ceph (réplication/backfill).",
        noSubnets: "Aucun Subnet enregistré — créez-les d'abord dans l'IPAM",
        sameSubnet: 'Même subnet pour le trafic public et cluster',
        sameSubnetHint: "Cochée = le réseau cluster (réplication/backfill) coïncide avec le public. Décochée = choisissez son propre subnet ET l'adresse du nœud de contrôle à l'intérieur.",
        controlAddress: 'Adresse du nœud de contrôle',
        controlAddressHint: "Une adresse que l'IPAM connaît pour le nœud dans le subnet public.",
        controlClusterAddress: 'Adresse cluster du nœud de contrôle',
        controlClusterAddressHint: "Une adresse que l'IPAM connaît pour le nœud dans le subnet cluster.",
        noAddresses: "L'IPAM ne connaît aucune adresse de ce nœud dans le subnet choisi",
        started: "Cluster créé — le bootstrap se poursuit comme macrotask ; la phase se met à jour d'elle-même",
        error: 'Le cluster a été refusé'
      },
      detail: {
        actions: 'Actions disponibles',
        tabOverview: "Vue d'ensemble",
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pools',
        tabObjects: 'Objets',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Avancé',
        phase: 'Phase',
        checksTitle: 'Checks de santé actifs',
        noChecks: 'Aucun check de santé actif',
        checkMuted: 'en sourdine',
        summaryPools: 'Pools',
        summaryFilesystems: 'Filesystems',
        nodesCard: 'Nœuds',
        monHint: 'Un MGR tourne colocalisé avec chaque MON. Trois MON sont le quorum recommandé ; un cluster de laboratoire démarre avec un seul. OSD et MDS vivent dans leurs propres tabs.',
        monHintSplit: 'MON et MGR sont disjoints sur ce cluster (Avancé) : chaque rôle est une membership propre par nœud. Trois MON sont le quorum recommandé ; au moins un MGR doit exister.',
        noMons: 'Aucun monitor déclaré',
        addNode: 'Ajouter un nœud',
        removeNode: 'Retirer le nœud',
        removeNodeFrom: 'Retirer le nœud {node} (son MON et le MGR colocalisé)',
        roleMon: 'Rôle MON',
        roleMgr: 'Rôle MGR',
        roleNa: 'N/A',
        roleNotObserved: 'pas encore observé',
        monInQuorum: 'dans le quorum',
        monOutQuorum: 'hors quorum',
        mgrActive: 'actif',
        mgrStandby: 'standby',
        addRoleMon: 'Ajouter le rôle MON',
        removeRoleMon: 'Retirer le rôle MON',
        addRoleMgr: 'Ajouter le rôle MGR',
        removeRoleMgr: 'Retirer le rôle MGR',
        restartMon: 'Redémarrer le service MON',
        restartMgr: 'Redémarrer le service MGR',
        addMon: 'Ajouter un MON',
        removeMon: 'Retirer le MON',
        removeMonFrom: 'Retirer le rôle MON de {node}',
        addMgr: 'Ajouter un MGR',
        removeMgr: 'Retirer le MGR',
        removeMgrFrom: 'Retirer le rôle MGR de {node}',
        addMds: 'Ajouter un MDS',
        removeMds: 'Retirer le MDS',
        removeMdsFrom: 'Retirer le rôle MDS de {node}',
        mdsSection: 'Metadata servers (MDS)',
        noMds: "Aucun MDS déclaré — un filesystem en exige d'abord un",
        mdsHint: "La membership MDS est propre dès le premier jour : un cluster sans CephFS n'en déclare aucun, un actif plus un standby servent bien un filesystem. Ceph élit actifs et standbys parmi les daemons déclarés.",
        mdsActiveFor: 'actif — {fs}',
        mdsNotObserved: 'pas encore observé',
        lastMdsGuard: "Le dernier MDS ne peut pas être retiré tant qu'un filesystem existe — retirez d'abord les filesystems",
        lastMonGuard: 'Le dernier MON ne peut pas être retiré — détruire le cluster est la seule sortie',
        lastMgrGuard: 'Le dernier MGR ne peut pas être retiré — un cluster géré ne tourne jamais sans manager',
        registerDevice: 'Ajouter un OSD',
        unregisterDevice: 'Désenregistrer',
        activeDeviceGuard: 'OSD actif — il sort par le cycle de vie OSD, pas par le registre',
        colNode: 'Nœud',
        devicePhase: { registered: 'Enregistré', active: 'Actif' },
        health: 'Santé',
        state: 'État',
        fsid: 'fsid',
        fsidPending: 'absent — réessayez le bootstrap',
        version: 'Version Ceph',
        publicNetwork: 'Réseau public',
        clusterNetwork: 'Réseau cluster',
        clusterNetworkCollapsed: '= public',
        noActions: 'Aucune action disponible dans cette phase',
        destroyedNote: 'Cluster détruit — la ligne est retirée automatiquement sous peu'
      },
      overview: {
        services: 'Services',
        ok: 'en bonne santé',
        warning: 'warning',
        down: 'hors service',
        pgTitle: 'États des PG',
        pgTotal: '{n} PG au total',
        capacityTitle: 'Espace',
        ioTitle: 'I/O actuel',
        ioReadBw: 'Bande passante en lecture',
        ioWriteBw: 'Bande passante en écriture',
        ioReadIops: 'IOPS en lecture',
        ioWriteIops: 'IOPS en écriture',
        notObserved: 'pas encore observé'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'État',
        colSize: 'Taille',
        colPgs: 'PG',
        empty: 'Aucun OSD — ajoutez-en un depuis un disque de données déclaré',
        markIn: 'Marquer IN',
        markOut: 'Marquer OUT',
        scrub: 'Lancer un scrub',
        deepScrub: 'Lancer un scrub profond',
        restart: 'Redémarrer le service',
        details: 'Détails',
        actionGuard: "Seulement sur un OSD actif d'un cluster déployé",
        inTitle: "Marquer l'OSD IN",
        inBody: 'osd.{id} revient dans la distribution des données (ceph osd in) : Ceph rééquilibre les données vers lui.',
        outTitle: "Marquer l'OSD OUT",
        outBody: 'osd.{id} sort de la distribution des données (ceph osd out) : ses données se rééquilibrent ailleurs et la redondance est RÉDUITE tant que le backfill tourne. Réversible à tout moment avec Marquer IN.',
        scrubTitle: 'Planifier un scrub',
        scrubBody: "Un scrub de osd.{id} est planifié : le mon le met en file et les états des PG des sweeps suivants racontent l'issue.",
        deepScrubTitle: 'Planifier un scrub profond',
        deepScrubBody: "Un scrub profond de osd.{id} est planifié : la variante qui vérifie les octets — plus lourde sur l'I/O, même mécanique.",
        restartTitle: 'Redémarrer le service OSD',
        restartBody: 'osd.{id} est arrêté puis redémarré à travers la supervision du worker sur son nœud.',
        started: "Action lancée — l'observation se met à jour d'elle-même",
        error: "L'action OSD a été refusée"
      },
      osdDetail: {
        title: 'Détails OSD',
        tabGeneral: 'Général',
        tabNetwork: 'Réseau',
        tabDevices: 'Périphériques',
        version: 'Version',
        hostname: 'Hostname',
        dataPath: 'Chemin des données OSD',
        objectStore: 'Object store OSD',
        encrypted: 'Chiffré',
        yes: 'Oui',
        no: 'Non',
        memory: 'Utilisation mémoire (PSS)',
        pid: 'Process ID (PID)',
        front: 'Adresse front (client & monitor)',
        hbFront: 'Adresse heartbeat front',
        back: 'Adresse back (OSD)',
        hbBack: 'Adresse heartbeat back',
        colDevice: 'Device',
        colType: 'Type',
        colPhysical: 'Device physique',
        colSize: 'Taille',
        volumeTitle: 'Détails du volume',
        creationTime: 'Date de création',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Aucun device observé pour cet OSD'
      },
      restart: {
        title: 'Redémarrer le service',
        monBody: 'Le daemon MON sur {node} est arrêté puis redémarré à travers la supervision du worker.',
        mgrBody: 'Le daemon MGR sur {node} est arrêté puis redémarré à travers la supervision du worker.',
        started: "Redémarrage lancé — l'observation se met à jour d'elle-même",
        error: 'Le redémarrage a été refusé'
      },
      encryptionMode: {
        alwaysOn: 'Toujours activé (dmcrypt)',
        alwaysOff: 'Toujours désactivé',
        perOsd: 'Choisi par OSD',
        section: 'Chiffrement OSD at rest',
        title: 'Changer le mode de chiffrement OSD',
        hint: "Comment sont préparés les NOUVEAUX OSD. Les OSD existants gardent leur état par disque : pour en changer un, on retire et on recrée l'OSD.",
        body: 'Le mode devient "{mode}" et ne vaut QUE pour les NOUVEAUX OSD : chaque OSD existant garde son état de chiffrement actuel.',
        apply: 'Changer le mode',
        error: 'Le changement de mode a été refusé'
      },
      pin: {
        address: 'Adresse public (pin optionnel)',
        clusterAddress: 'Adresse cluster (pin optionnel)',
        autoPlaceholder: 'automatique dans le subnet {cidr}',
        hint: "Adressage par daemon : vide = Ceph se lie tout seul dans le réseau déclaré ; renseigné = cette instance est épinglée à l'adresse dans sa section de conf."
      },
      addMon: {
        title: 'Ajouter un nœud',
        node: 'Nœud',
        address: 'Adresse public',
        addressHint: "Les adresses du nœud que l'IPAM connaît dans le subnet public — automatique quand une déclaration existante couvre le nœud.",
        clusterAddress: 'Adresse cluster',
        clusterAddressHint: "Obligatoire : le subnet cluster est séparé et le nœud n'y est pas encore déclaré.",
        noAddresses: "L'IPAM ne connaît aucune adresse de ce nœud dans le subnet",
        error: "L'ajout du mon a été refusé"
      },
      removeMon: {
        title: 'Retirer le MON',
        body: 'Le MON et son MGR colocalisé quittent le nœud {node}. Sur un cluster déployé, les daemons sont arrêtés et retirés du quorum.',
        error: 'Le retrait du MON a été refusé'
      },
      addMgr: {
        title: 'Ajouter un MGR',
        node: 'Nœud',
        hint: "Avancé (MON/MGR disjoints) : un manager standalone naît sur le nœud membre choisi via une task affine au nœud. L'élection active/standby de Ceph choisit toute seule le MGR actif.",
        error: "L'ajout du MGR a été refusé"
      },
      removeMgr: {
        title: 'Retirer le MGR',
        body: "Le MGR standalone quitte le nœud {node}. Sur un cluster déployé, le daemon est arrêté et son état retiré ; le MON du nœud (s'il existe) n'est pas touché.",
        error: 'Le retrait du MGR a été refusé'
      },
      addMds: {
        title: 'Ajouter un MDS',
        node: 'Nœud',
        hint: 'Le metadata server de CephFS : il naît sur le nœud membre choisi via une task affine au nœud, supervisé par le worker comme MON et MGR. Ceph élit tout seul actifs et standbys — un actif plus un standby servent bien un filesystem.',
        error: "L'ajout du MDS a été refusé"
      },
      removeMds: {
        title: 'Retirer le MDS',
        body: "Le MDS quitte le nœud {node}. Sur un cluster déployé, le daemon est arrêté et son état retiré ; l'API refuse le dernier MDS tant qu'un filesystem en a besoin.",
        error: 'Le retrait du MDS a été refusé'
      },
      split: {
        title: 'MON/MGR disjoints',
        label: 'Autoriser MON et MGR sur des nœuds disjoints',
        hint: 'Désactivé (défaut) = le standard ratifié : un MGR tourne colocalisé avec chaque MON, une seule membership. Activé = la membership des MGR devient propre, gérée avec les actions Ajouter/Retirer MGR dans le tab Nœuds de gestion.',
        enable: 'Activer',
        disable: 'Désactiver',
        enableBody: "La membership des MGR devient indépendante des MON, initialisée depuis la colocalisation actuelle. Les actions Ajouter/Retirer MGR s'arment dans le tab Nœuds de gestion. Cela relâche le défaut de la plateforme — gardez-le seulement si vous savez pourquoi vous en avez besoin.",
        disableBody: "Retour à la colocalisation standard : un MGR avec chaque MON, une seule membership. Légal seulement si la membership des MGR coïncide déjà avec les MON — alignez-la d'abord avec Ajouter/Retirer MGR, ou l'API refusera.",
        error: 'La modification a été refusée'
      },
      rawEditor: {
        title: 'Éditeur CRUSH brut',
        label: "Afficher l'éditeur brut de la crushmap dans le tab CRUSH",
        hint: "Désactivé (défaut) = la surface guidée des règles est l'outil standard. Activé = le tab CRUSH montre aussi la crushmap décompilée comme texte éditable. L'enregistrement exige toujours sudo, le nom du cluster comme confirmation, et passe par compile + test de crushtool AVANT d'atteindre le cluster."
      },
      osdFlags: {
        section: 'Flags OSD globaux',
        title: 'Override des flags OSD',
        notObserved: 'pas encore observés',
        standardFlowsHint: "Les flux standard de la plateforme gèrent ces flags tout seuls dans les cas normaux (la maintenance d'un nœud pose un noout ciblé, le remplacement de disque passe par le cycle de vie OSD). Cette section est l'override manuel pour l'opérateur qui sait ce qu'il fait.",
        notDeployedGuard: "Les flags OSD n'existent que sur un cluster déployé",
        set: 'Poser le flag',
        unset: 'Retirer le flag',
        setBody: "Le flag global {flag} sera POSÉ sur l'osdmap. Il reste tant qu'il n'est pas retiré explicitement — un flag oublié dégrade l'auto-réparation du cluster.",
        unsetBody: "Le flag global {flag} sera RETIRÉ de l'osdmap.",
        error: 'La modification du flag a été refusée',
        flag: {
          noout: "Aucun OSD n'est marqué out de la distribution des données — pas de rééquilibrage à la perte d'un daemon",
          norebalance: 'Le rééquilibrage des données est suspendu',
          nobackfill: 'Le backfill est suspendu',
          norecover: 'Le recovery est suspendu',
          pause: "TOUT l'I/O des clients est en pause (lectures et écritures)",
          noin: 'Les OSD qui démarrent ne sont pas marqués in automatiquement',
          nodown: 'Les OSD injoignables ne sont pas marqués down — masque des pannes réelles'
        }
      },
      pools: {
        section: 'Pools',
        create: 'Créer un pool',
        createGuard: "Les pools n'existent que sur un cluster déployé",
        notObserved: 'Aucune observation des pools — le sweep du mon rapporte ici',
        empty: 'Aucun pool sur le cluster',
        colName: 'Nom',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Application',
        colRule: 'Règle CRUSH',
        colUsage: 'Utilisation',
        observedAtLabel: 'Observé le',
        objects: '{n} objets',
        inUseBy: 'utilisé par {name}',
        internalGuard: 'Pool interne de Ceph — la plateforme ne le supprime jamais',
        delete: 'Supprimer le pool',
        deleteGuard: "Consommé par le storage {name} — supprimez d'abord le storage",
        hint: 'Pools répliqués seulement (erasure coding hors scope v1). La réplication vit dans Ceph : cette table est la vérité observée par le sweep du mon.',
        createTitle: 'Créer un pool',
        createHint: 'Le pool naît sur le cluster avec la réplication demandée et l\'application rbd activée — le travail est fait par une task sur un nœud MON. Activez "Proposer comme storage" pour le consommer tout de suite dans le même geste.',
        name: 'Nom du pool',
        nameHint: 'DNS-safe (minuscules, chiffres, tirets).',
        size: 'Répliques (size)',
        sizeHint: 'Copies de chaque objet. Défaut 3.',
        minSize: 'Répliques minimales (min_size)',
        minSizeHint: "Copies minimales pour servir l'I/O — suit size − 1 tant que vous ne le modifiez pas.",
        createError: 'La création du pool a été refusée',
        deleteTitle: 'Supprimer le pool',
        deleteBody: "Le pool {pool} et CHAQUE objet à l'intérieur sont détruits irréversiblement. Saisissez le nom du pool pour confirmer.",
        confirmLabel: 'Nom du pool',
        confirmHint: 'Saisissez le nom du pool pour confirmer',
        deleteError: 'La suppression du pool a été refusée',
        detailTitle: 'Détails du pool',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Activé',
        autoscalerOff: 'Désactivé',
        autoscalerWarn: 'Notifier',
        pgNumLabel: 'Nombre de PG',
        pgNumCaption: "Observé : l'autoscaler peut le changer de lui-même — ce champ écrit un souhait.",
        storage: 'Storage TVirt associé',
        addAsStorage: 'Ajouter comme storage TVirt',
        ruleSudoHint: 'Le changement de règle CRUSH exige le mot de passe opérateur.',
        updateError: 'La modification du pool a été refusée',
        updated: "Modification du pool lancée — l'observation se met à jour d'elle-même"
      },
      crush: {
        section: 'Règles CRUSH',
        notObserved: 'Aucune observation CRUSH pour le moment — le sweep du mon rapporte ici',
        empty: 'Aucune règle observée sur le cluster',
        hint: "Une règle décide OÙ atterrissent les copies de chaque objet — son domaine de panne est l'unité qui peut tomber sans perdre de données. Les pools pointent vers une règle ; la replicated_rule builtin (une réplique par serveur) est le défaut de naissance.",
        create: 'Créer une règle',
        createGuard: "Les règles CRUSH n'existent que sur un cluster déployé",
        createTitle: 'Créer une règle CRUSH',
        createHint: 'Une règle = un choix de domaine de panne. La règle naît répliquée sur le root par défaut — le travail est fait par une task sur un nœud MON ; associez les pools depuis le tab Pools ensuite.',
        createError: 'La création de la règle a été refusée',
        name: 'Nom de la règle',
        nameHint: 'DNS-safe (minuscules, chiffres, tirets).',
        domain: 'Domaine de panne',
        domainChoice: {
          osd: 'Chaque réplique sur un OSD différent',
          host: 'Chaque réplique sur un serveur différent',
          rack: 'Chaque réplique dans un rack différent'
        },
        domainCustom: 'Personnalisé (steps écrits à la main)',
        domainOther: 'Chaque réplique dans un {type} différent',
        rackGuardHint: "Aucun bucket rack n'existe dans la hiérarchie observée : la règle peut être créée quand même, mais aucun pool ne pourra pointer vers elle tant qu'un rack n'est pas déclaré dans le placement des serveurs membres (réglages du nœud) — la task de réalignement construit le bucket et l'association s'ouvre d'elle-même.",
        treeTitle: 'Hiérarchie observée',
        treeNotObserved: 'Aucune observation de la hiérarchie — le sweep du mon rapporte ici',
        treeOsds: '{n} OSD',
        treeHint: 'La map CRUSH comme le cluster la voit : root → niveaux déclarés → serveurs (hosts) → OSD. La topologie suit le placement déclaré de chaque serveur (réglages du nœud) — un changement de position la réaligne via une task.',
        unplacedWarning: 'Membres sans position déclarée : {nodes} — leurs hosts restent directement sous la root, hors de la topologie déclarée. Déclarez la position dans les réglages du nœud (un avertissement, jamais un blocage).',
        colName: 'Nom',
        colDomain: 'Domaine de panne',
        colPools: 'Pools',
        builtinChip: 'builtin',
        builtinGuard: 'La règle par défaut du cluster — la plateforme ne la supprime jamais',
        detailAction: 'Détail de la règle',
        detailType: 'Type',
        backToRules: 'Règles',
        ruleNotObserved: 'La liste observée des règles ne nomme pas cette règle',
        noPools: 'Aucun pool ne chevauche cette règle',
        delete: 'Supprimer la règle',
        deleteTitle: 'Supprimer la règle CRUSH',
        deleteBody: 'La règle {rule} est retirée de la crushmap du cluster. Aucun pool ne doit la chevaucher. Saisissez le nom de la règle pour confirmer.',
        deleteGuard: "Chevauchée par le pool {name} — repointez d'abord le pool",
        confirmLabel: 'Nom de la règle',
        confirmHint: 'Saisissez le nom de la règle pour confirmer',
        deleteError: 'La suppression de la règle a été refusée',
        changeRule: 'Changer la règle CRUSH',
        changeRuleTitle: 'Changer la règle CRUSH',
        changeRuleHint: 'Le pool commence à placer ses objets selon la règle choisie — Ceph déplace les données existantes pour se conformer (sur un pool plein, un rééquilibrage suit).',
        changeRuleError: 'Le changement de règle a été refusé',
        rule: 'Règle CRUSH',
        rawTitle: 'Crushmap brute (décompilée)',
        rawWarning: "DANGER : ce texte est TOUTE la politique de placement du cluster. Une map erronée peut casser le placement de tous les pools à la fois. L'enregistrement compile et éprouve la map avec crushtool AVANT de l'injecter — mais une map valide peut quand même être une mauvaise idée.",
        rawReload: 'Recharger',
        rawLoading: 'Query en vol — une task read-only est en train de décompiler la crushmap…',
        rawSave: 'Enregistrer la crushmap',
        rawSaveTitle: 'Injecter la crushmap',
        rawSaveBody: 'Le texte modifié remplace la crushmap du cluster TOUT ENTIER après compile + test de crushtool. Saisissez le nom du cluster pour confirmer.',
        rawConfirmLabel: 'Nom du cluster',
        rawConfirmHint: 'Saisissez {name} pour confirmer',
        rawError: "L'opération sur la crushmap a échoué",
        rawHint: "Le texte est la forme crushtool -d. Les erreurs de compilation et de test reviennent mot pour mot de crushtool — la map n'atteint pas le cluster si l'un des deux verrous échoue."
      },
      objects: {
        poolsSection: "Explorateur d'objets",
        poolsHint: "Choisissez un pool pour lister ses images RBD. Chaque lecture profonde tourne comme task read-only sur un nœud MON — elle ne bloque pas (ni n'est bloquée par) les opérations réelles.",
        deployedGuard: 'Les query sur les objets ne répondent que sur un cluster déployé',
        browse: 'Parcourir les objets',
        detailAction: "Détail de l'image",
        backToPools: 'Pools',
        backToImages: 'Images',
        refresh: 'Rafraîchir',
        loading: "Query en vol — une task read-only est en train d'interroger le cluster…",
        error: 'La query a échoué',
        retry: 'Réessayer',
        notRbd: 'Pool avec application "{app}" — il ne contient pas d\'images RBD, rien à explorer ici',
        noImages: 'Aucune image RBD dans ce pool',
        colImage: 'Image',
        colSize: 'Taille',
        colObjects: 'Objets',
        colSnapshots: 'Snapshots',
        imagesHint: "Les disques sur un storage rbd consommateur sont des images nommées par leur id de disque. Le compte d'objets est le provisioned (taille / taille d'objet) — l'usage réel vit dans le détail de l'image.",
        infoTitle: 'Image',
        infoSize: 'Taille virtuelle',
        infoObjects: 'Objets (provisioned)',
        infoObjectSize: "Taille d'objet",
        infoPrefix: 'Préfixe des objets',
        infoFormat: 'Format',
        infoFeatures: 'Features',
        usageTitle: 'Usage réel (rbd du)',
        usageOf: 'sur {provisioned} GiB provisioned',
        usageHint: 'Thin par nature : seuls les objets écrits occupent des octets.',
        watchersTitle: 'Watchers',
        noWatchers: "Aucun watcher — personne n'a cette image ouverte en ce moment",
        snapshotsTitle: 'Snapshots RBD',
        noSnapshots: 'Aucun snapshot RBD sur cette image',
        colSnapshot: 'Snapshot',
        colProtected: 'Protégé',
        colTimestamp: 'Créé',
        protected: 'protégé',
        mappingTitle: 'Placement physique (ensemble OSD)',
        mappingSampled: "Échantillon de {sampled} objets sur {total} — un résumé honnête : pour les grandes images, l'ensemble converge vers TOUS les OSD du pool (CRUSH distribue les objets sur tout le pool).",
        mappingComplete: 'Tous les objets mappés ({total} sur {total}).',
        objectQueryTitle: 'Mapper un objet unique',
        objectName: "Nom de l'objet",
        objectHint: "Les noms d'objet RADOS sont <préfixe>.<index 16-hex> — ceph osd map répond avec le PG et les triplets OSD.",
        mapObject: 'Mapper',
        primary: 'primaire : osd.{osd}'
      },
      registerDevice: {
        title: 'Enregistrer un périphérique OSD',
        hint: "Sur un cluster vivant, l'enregistrement PRÉPARE aussi le périphérique : il devient un OSD BlueStore via une task automatique affine au nœud (jamais vide, ratifié 2026-07-24). Un périphérique appartient au plus à un cluster Ceph dans toute la flotte.",
        disk: 'Disque de données',
        diskHint: 'Les disques de données déclarés du nœud — nom et numéro de série',
        noDeclared: "Aucun disque de données déclaré sur ce nœud — marquez-les d'abord dans les réglages locaux du nœud",
        serialHint: "Le numéro de série du périphérique — le pin d'identité",
        encrypted: 'Chiffrer cet OSD (dmcrypt)',
        encryptedHint: 'Le choix par OSD (le mode du cluster est "choisi par OSD") : il se fige sur ce disque à l\'enregistrement — un changement de mode ultérieur ne le réécrit jamais ; c\'est l\'action de ligne chiffrer/déchiffrer qui le fait.',
        error: "L'enregistrement a été refusé"
      },
      unregisterDevice: {
        title: 'Désenregistrer le périphérique',
        body: "Registre seulement : {name} cesse d'être un candidat OSD de ce cluster. Ses octets ne sont pas touchés.",
        error: 'Le désenregistrement a été refusé'
      },
      deploy: {
        action: 'Réessayer le déploiement',
        title: 'Réessayer le bootstrap',
        body: "Le bootstrap de naissance repart de la configuration actuelle : les mons démarrent, chaque périphérique enregistré est préparé et activé comme OSD BlueStore. L'opération tourne comme macrotask — la phase se met à jour d'elle-même.",
        started: "Bootstrap lancé — il se poursuit comme macrotask ; la phase se met à jour d'elle-même",
        error: 'Le bootstrap a été refusé'
      },
      propose: {
        action: 'Proposer comme storage',
        title: 'Proposer comme storage',
        hintPool: "Le pool existant {name} devient un storage TVirt : une identité cephx limitée au pool atterrit dans le keystore et le storage ceph-rbd naît prêt. La proposition consomme le pool — elle n'en crée jamais.",
        hintFs: "Le filesystem existant {name} devient un storage TVirt : une identité cephx limitée au filesystem atterrit dans le keystore et le storage cephfs naît prêt et monté. La proposition consomme le filesystem — elle n'en crée jamais.",
        name: 'Nom du storage',
        nameHint: "DNS-1123, unique dans le scope — l'identité cephx prend son nom de lui.",
        path: 'Path dans le filesystem',
        pathHint: 'Path absolu dans le filesystem que le storage monte — / en cas de doute.',
        alsoPropose: 'Proposer tout de suite comme storage',
        alsoProposePoolHint: 'Après la création, le même geste propose le pool qui vient de naître comme storage ceph-rbd — deux appels explicites, un seul dialog.',
        alsoProposeFsHint: 'Après la création, le même geste propose le filesystem qui vient de naître comme storage cephfs — deux appels explicites, un seul dialog.',
        guard: 'Proposer comme storage — seulement sur un cluster healthy',
        started: 'Proposition acceptée — le storage est en train de se matérialiser ; retrouvez-le sous Storage',
        submit: 'Créer le storage',
        error: 'La proposition a été refusée'
      },
      fs: {
        section: 'Filesystems',
        create: 'Créer un filesystem',
        createGuard: "Les filesystems n'existent que sur un cluster déployé",
        mdsFirstGuard: "Ajoutez d'abord un MDS — un filesystem sans metadata server naît inutilisable",
        notObserved: 'Aucune observation des filesystems — le sweep du MON rapporte ici',
        empty: 'Aucun filesystem sur le cluster',
        colName: 'Nom',
        colPools: 'Pools',
        colMds: 'MDS',
        noActiveMds: 'aucun MDS actif',
        delete: 'Retirer le filesystem',
        deleteGuard: "Consommé par le storage {name} — supprimez d'abord le storage",
        hint: 'Un filesystem possède ses pools de données et de metadata (cephfs.<nom>.data / .meta) : ils naissent avec lui et meurent avec lui — removeFs, jamais un delete de pool à la main. Cette table est la vérité observée par le sweep du MON.',
        createTitle: 'Créer un filesystem',
        createHint: 'Le filesystem naît sur le cluster avec ses deux pools (application cephfs) et est servi par les MDS déclarés — le travail est fait par une task sur un nœud MON. Activez "Proposer comme storage" pour le consommer tout de suite dans le même geste.',
        name: 'Nom du filesystem',
        nameHint: 'DNS-safe (minuscules, chiffres, tirets).',
        sizeHint: 'Répliques des DEUX pools naissants. Défaut 3.',
        createError: 'La création du filesystem a été refusée',
        deleteTitle: 'Retirer le filesystem',
        deleteBody: "Le filesystem {fs} et CHAQUE fichier à l'intérieur sont détruits irréversiblement — ses pools de données et de metadata meurent avec lui. Saisissez le nom du filesystem pour confirmer.",
        confirmLabel: 'Nom du filesystem',
        confirmHint: 'Saisissez le nom du filesystem pour confirmer',
        deleteError: 'Le retrait du filesystem a été refusé'
      },
      destroy: {
        action: 'Détruire',
        retryAction: 'Réessayer la destruction',
        retryGuard: 'La destruction est en cours — le retry vaut pour une destruction échouée (le lease refuse sinon)',
        title: 'Détruire le cluster',
        body: "Le fabric déployé est démantelé : chaque daemon de ce cluster s'arrête, son état système et ses clés dans le keystore sont libérés. Une fois la destruction réussie, le cluster est retiré automatiquement.",
        confirmLabel: 'Nom du cluster',
        confirmHint: 'Saisissez le nom du cluster pour confirmer',
        wipe: 'Effacer les périphériques enregistrés',
        wipeHint: 'Cochée : les signatures de chaque périphérique enregistré sont effacées — les données dessus sont détruites. Décochée : les octets restent intacts et les périphériques redeviennent enregistrés.',
        guard: 'Détruire — rien de déployé',
        started: "Destruction lancée — elle se poursuit comme macrotask ; la phase se met à jour d'elle-même",
        error: 'La destruction a été refusée'
      },
      delete: {
        guard: "Supprimer — seulement une configuration non déployée (détruisez d'abord)",
        title: 'Supprimer {name} ?',
        body: "La configuration et son registre de périphériques sont retirés. Légal seulement tant que rien n'est déployé.",
        error: 'La suppression a été refusée'
      }
    }
  }
}
